"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmeraldLisItemCoreInputs = void 0;
const list_item_variant_1 = require("./list-item.variant");
class EmeraldLisItemCoreInputs {
    constructor() {
        this.enableRipple = true;
        this.prefixType = list_item_variant_1.EmeraldListItemVariant.DEFAULT;
        this.suffixType = list_item_variant_1.EmeraldListItemVariant.DEFAULT;
    }
}
exports.EmeraldLisItemCoreInputs = EmeraldLisItemCoreInputs;
//# sourceMappingURL=list-item.inputs.js.map